// extracted by mini-css-extract-plugin
export default {"heading-title":"styles_heading-title__FAubu","cell-title":"styles_cell-title__IkLmw"};